// What each screen can read, and — when it cannot — the screen that can. Pure: no React, no fetch.
//
// The rule these helpers hold (REQ-063-AC3): a screen that refuses a file NAMES THE SCREEN THAT CAN
// READ IT, never only the format it wanted. Don had his contact workbook open on Import Data and read
// "it's got to be a csv file"; the screen one route over had accepted that workbook all along, and
// nothing on the screen he was standing on said so.

/** The accept attribute for every screen that asks for a contact list. One list, one place. */
export const CONTACT_LIST_ACCEPT =
  '.xlsx,.xls,.csv,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

/** What the dropzone says it takes, in the person's words rather than MIME types. */
export const CONTACT_LIST_HINT = 'Excel workbook · LinkedIn Connections.csv · CRM export'

const CONTACT_LIST_EXTENSIONS = ['.xlsx', '.xls', '.xlsm', '.csv', '.txt']

function extensionOf(fileName: string): string {
  const dot = fileName.lastIndexOf('.')
  return dot < 0 ? '' : fileName.slice(dot).toLowerCase()
}

/** Is this the kind of file a contact list arrives as? The API's reader is the authority; this is
 *  only ever used to decide where to point somebody. */
export function isContactList(fileName: string): boolean {
  return CONTACT_LIST_EXTENSIONS.includes(extensionOf(fileName))
}

/**
 * What a screen that asks for a contact list says about a file it cannot read. Null when the file is
 * fine. The message names both doors, because either one reads it.
 */
export function refuseContactList(fileName: string): string | null {
  if (isContactList(fileName)) return null
  const ext = extensionOf(fileName)
  return `Scout cannot read ${fileName} as a contact list${ext ? ` — ${ext} is not a spreadsheet` : ''}. ` +
    'A contact list is an Excel workbook (.xlsx, .xls) or a CSV export, and both Import Data and Onboard Contacts read either one.'
}

/**
 * What the mailbox screen says when somebody offers it a contact list instead of a mail export.
 * Null when the file is not a contact list — the API says what it makes of anything else.
 */
export function refuseOnMailbox(fileName: string): string | null {
  if (!isContactList(fileName)) return null
  return `${fileName} looks like a contact list, not a mail export. Excel workbooks and CSV contact exports go through Onboard Contacts →.`
}
